import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import localStyles from './styles.less';

const CheckboxComponent = ({ t, updateContent, freeCourse, name }) => (
  <div className={localStyles.checkbox}>
    <Checkbox
      onChange={e => updateContent('free_course', e.target.checked)}
      defaultChecked={freeCourse}
      checked={freeCourse}
      name={name}
    >
      {t('details.course.free')}
    </Checkbox>
  </div>
);

CheckboxComponent.propTypes = {
  updateContent: PropTypes.func,
  t: PropTypes.func,
  freeCourse: PropTypes.bool,
  name: PropTypes.string,
};

CheckboxComponent.defaultProps = {
  updateContent: () => {},
  t: () => {},
  freeCourse: null,
  name: '',
};

export default CheckboxComponent;
